// Code generated by protoc-gen-epp-api-js. DO NOT EDIT.

import axios from "axios";

const dev = process.env.NODE_ENV !== 'production';

let globalConfig = window.EPPConfig || {};
let eppInstanceConfig = {
  // base_url: globalConfig.base_url || (dev ? 'http://localhost:8081' : window.location.origin)
  base_url: globalConfig.base_url || (dev ? 'http://185.38.110.122:8081' : window.location.origin)
};

if (eppInstanceConfig.base_url === "") {
  alert("Missing or empty EPP API Server URL configuration(window.EPPConfig.base_url)");
}

let sessionToken = null;
let tokenHandler = null;
let globalNoker = null;
let preFlight = null;
let postFlight = null;

function invokePreFlight(method) {
  if (typeof preFlight === "function") {
    preFlight(method)
  }
}

function invokePostFlight(method) {
  if (typeof postFlight === "function") {
    postFlight(method)
  }
}

const client = axios.create({
  baseURL: eppInstanceConfig.base_url,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

function tokenH(headers, handler) {
  let token = headers["x-epp-api-session"] || "";
  if (token === "") {
    return;
  }
  sessionToken = token;
  if (typeof handler === "function") {
    handler(sessionToken);
  }
}

function oker(data, handler, method) {
  invokePostFlight(method);
  if (typeof handler !== "function") {
    handler = console.log;
  }
  handler(data);
}

function noker(error, handler, method) {
  invokePostFlight(method);
  handler = handler || globalNoker;

  if (typeof handler !== "function") {
    handler = console.log;
  }

  let info = {
    code: 0,
    httpMessage: "",
    message: "",
  };

  if (error.response) {

    if (error.response.status) {
      info.code = error.response.status;
    }

    if (error.response.statusText) {
      info.httpMessage = error.response.statusText;
    }

    if (error.response.data && error.response.data.message) {
      info.message = error.response.data.message;
    }

  } else if (error.request) {
    info.message = 'Server is not responding or the request could not be performed on the endpoint.';
  } else {
    info.message = 'Failed to send request. Malformed configuration? See console for more information.';
    console.error(error);
  }

  handler(info);
}

function authRequest(sessionToken) {
  return { "headers": { "Authorization": "Bearer " + sessionToken } };
}

export default {

  setSession(token) {
    sessionToken = token;
  },

  setGlobalNoker(fn) {
    globalNoker = fn;
  },

  setTokenHandler(fn) {
    tokenHandler = fn;
  },

  setPreFlight(fn) {
    preFlight = fn;
  },

  setPostFlight(fn) {
    postFlight = fn;
  },

  approveDomainTransfer(req, ok, nok) {
    invokePreFlight("approveDomainTransfer");
    client
      .post('/api/transfer:approve', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "approveDomainTransfer"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "approveDomainTransfer") })
      .catch((error) => noker(error, nok, "approveDomainTransfer"))
  },

  approvePendingDomainCreateRequest(req, ok, nok) {
    invokePreFlight("approvePendingDomainCreateRequest");
    client
      .post('/api/domain:approvePendingCreate', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "approvePendingDomainCreateRequest"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "approvePendingDomainCreateRequest") })
      .catch((error) => noker(error, nok, "approvePendingDomainCreateRequest"))
  },

  cancelDomainTransfer(req, ok, nok) {
    invokePreFlight("cancelDomainTransfer");
    client
      .post('/api/transfer:cancel', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "cancelDomainTransfer"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "cancelDomainTransfer") })
      .catch((error) => noker(error, nok, "cancelDomainTransfer"))
  },

  changeContactRegistrar(req, ok, nok) {
    invokePreFlight("changeContactRegistrar");
    client
      .post('/api/contact:changeRegistrar', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeContactRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeContactRegistrar") })
      .catch((error) => noker(error, nok, "changeContactRegistrar"))
  },

  changeDomainContact(req, ok, nok) {
    invokePreFlight("changeDomainContact");
    client
      .post('/api/domain:changeContact', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeDomainContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeDomainContact") })
      .catch((error) => noker(error, nok, "changeDomainContact"))
  },

  changeDomainRegistrar(req, ok, nok) {
    invokePreFlight("changeDomainRegistrar");
    client
      .post('/api/domain:changeRegistrar', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeDomainRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeDomainRegistrar") })
      .catch((error) => noker(error, nok, "changeDomainRegistrar"))
  },

  changeDomainServerStatuses(req, ok, nok) {
    invokePreFlight("changeDomainServerStatuses");
    client
      .post('/api/domain:changeServerStatuses', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeDomainServerStatuses"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeDomainServerStatuses") })
      .catch((error) => noker(error, nok, "changeDomainServerStatuses"))
  },

  changeUserAuthQuestions(req, ok, nok) {
    invokePreFlight("changeUserAuthQuestions");
    client
      .post('/api/user:changeAuthQuestions', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeUserAuthQuestions"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeUserAuthQuestions") })
      .catch((error) => noker(error, nok, "changeUserAuthQuestions"))
  },

  changeUserPassword(req, ok, nok) {
    invokePreFlight("changeUserPassword");
    client
      .post('/api/user:changePassword', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "changeUserPassword"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "changeUserPassword") })
      .catch((error) => noker(error, nok, "changeUserPassword"))
  },

  configureFrontend(req, ok, nok) {
    invokePreFlight("configureFrontend");
    client
      .post('/api/frontend:configure', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "configureFrontend"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "configureFrontend") })
      .catch((error) => noker(error, nok, "configureFrontend"))
  },

  createContact(req, ok, nok) {
    invokePreFlight("createContact");
    client
      .post('/api/contact:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createContact") })
      .catch((error) => noker(error, nok, "createContact"))
  },

  createCreditTransaction(req, ok, nok) {
    invokePreFlight("createCreditTransaction");
    client
      .post('/api/credit:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createCreditTransaction"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createCreditTransaction") })
      .catch((error) => noker(error, nok, "createCreditTransaction"))
  },

  createDomain(req, ok, nok) {
    invokePreFlight("createDomain");
    client
      .post('/api/domain:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createDomain"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createDomain") })
      .catch((error) => noker(error, nok, "createDomain"))
  },

  createDomainTransfer(req, ok, nok) {
    invokePreFlight("createDomainTransfer");
    client
      .post('/api/transfer:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createDomainTransfer"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createDomainTransfer") })
      .catch((error) => noker(error, nok, "createDomainTransfer"))
  },

  createHost(req, ok, nok) {
    invokePreFlight("createHost");
    client
      .post('/api/host:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createHost"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createHost") })
      .catch((error) => noker(error, nok, "createHost"))
  },

  createRegistrar(req, ok, nok) {
    invokePreFlight("createRegistrar");
    client
      .post('/api/registrar:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createRegistrar") })
      .catch((error) => noker(error, nok, "createRegistrar"))
  },

  createTld(req, ok, nok) {
    invokePreFlight("createTld");
    client
      .post('/api/tld:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createTld"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createTld") })
      .catch((error) => noker(error, nok, "createTld"))
  },

  createUser(req, ok, nok) {
    invokePreFlight("createUser");
    client
      .post('/api/user:create', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "createUser"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "createUser") })
      .catch((error) => noker(error, nok, "createUser"))
  },

  deleteContact(req, ok, nok) {
    invokePreFlight("deleteContact");
    client
      .post('/api/contact:delete', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "deleteContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "deleteContact") })
      .catch((error) => noker(error, nok, "deleteContact"))
  },

  deleteDomain(req, ok, nok) {
    invokePreFlight("deleteDomain");
    client
      .post('/api/domain:delete', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "deleteDomain"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "deleteDomain") })
      .catch((error) => noker(error, nok, "deleteDomain"))
  },

  deleteFrontendTranslation(req, ok, nok) {
    invokePreFlight("deleteFrontendTranslation");
    client
      .post('/api/frontend/translate:delete', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "deleteFrontendTranslation"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "deleteFrontendTranslation") })
      .catch((error) => noker(error, nok, "deleteFrontendTranslation"))
  },

  deleteHost(req, ok, nok) {
    invokePreFlight("deleteHost");
    client
      .post('/api/host:delete', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "deleteHost"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "deleteHost") })
      .catch((error) => noker(error, nok, "deleteHost"))
  },

  deleteUser(req, ok, nok) {
    invokePreFlight("deleteUser");
    client
      .post('/api/user:delete', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "deleteUser"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "deleteUser") })
      .catch((error) => noker(error, nok, "deleteUser"))
  },

  getAlphaTldList(req, ok, nok) {
    invokePreFlight("getAlphaTldList");
    client
      .post('/api/settings/domains:getAlphaTldList', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getAlphaTldList"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getAlphaTldList") })
      .catch((error) => noker(error, nok, "getAlphaTldList"))
  },

  getDomainBlacklist(req, ok, nok) {
    invokePreFlight("getDomainBlacklist");
    client
      .post('/api/settings/domains:getBlackList', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getDomainBlacklist"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getDomainBlacklist") })
      .catch((error) => noker(error, nok, "getDomainBlacklist"))
  },

  getFrontendConfig(req, ok, nok) {
    invokePreFlight("getFrontendConfig");
    client
      .post('/api/frontend:getConfig', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getFrontendConfig"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getFrontendConfig") })
      .catch((error) => noker(error, nok, "getFrontendConfig"))
  },

  getFrontendTranslation(req, ok, nok) {
    invokePreFlight("getFrontendTranslation");
    client
      .post('/api/frontend/translation:get', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getFrontendTranslation"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getFrontendTranslation") })
      .catch((error) => noker(error, nok, "getFrontendTranslation"))
  },

  getRegistrarCredit(req, ok, nok) {
    invokePreFlight("getRegistrarCredit");
    client
      .post('/api/registrar:credit', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getRegistrarCredit"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getRegistrarCredit") })
      .catch((error) => noker(error, nok, "getRegistrarCredit"))
  },

  getUserAuthQuestions(req, ok, nok) {
    invokePreFlight("getUserAuthQuestions");
    client
      .post('/api/user:getAuthQuestions', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "getUserAuthQuestions"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "getUserAuthQuestions") })
      .catch((error) => noker(error, nok, "getUserAuthQuestions"))
  },

  listContacts(req, ok, nok) {
    invokePreFlight("listContacts");
    client
      .post('/api/collection:contact', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listContacts"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listContacts") })
      .catch((error) => noker(error, nok, "listContacts"))
  },

  listCreditTransactions(req, ok, nok) {
    invokePreFlight("listCreditTransactions");
    client
      .post('/api/collection:credit', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listCreditTransactions"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listCreditTransactions") })
      .catch((error) => noker(error, nok, "listCreditTransactions"))
  },

  listDomainTransfers(req, ok, nok) {
    invokePreFlight("listDomainTransfers");
    client
      .post('/api/collection:transfer', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listDomainTransfers"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listDomainTransfers") })
      .catch((error) => noker(error, nok, "listDomainTransfers"))
  },

  listDomains(req, ok, nok) {
    invokePreFlight("listDomains");
    client
      .post('/api/collection:domain', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listDomains"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listDomains") })
      .catch((error) => noker(error, nok, "listDomains"))
  },

  listEppLogs(req, ok, nok) {
    invokePreFlight("listEppLogs");
    client
      .post('/api/collection:epp-log', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listEppLogs"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listEppLogs") })
      .catch((error) => noker(error, nok, "listEppLogs"))
  },

  listEvents(req, ok, nok) {
    invokePreFlight("listEvents");
    client
      .post('/api/collection:events', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listEvents"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listEvents") })
      .catch((error) => noker(error, nok, "listEvents"))
  },

  listHosts(req, ok, nok) {
    invokePreFlight("listHosts");
    client
      .post('/api/collection:host', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listHosts"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listHosts") })
      .catch((error) => noker(error, nok, "listHosts"))
  },

  listPendingRequests(req, ok, nok) {
    invokePreFlight("listPendingRequests");
    client
      .post('/api/collection:pending', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listPendingRequests"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listPendingRequests") })
      .catch((error) => noker(error, nok, "listPendingRequests"))
  },

  listRegistrars(req, ok, nok) {
    invokePreFlight("listRegistrars");
    client
      .post('/api/collection:registrar', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listRegistrars"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listRegistrars") })
      .catch((error) => noker(error, nok, "listRegistrars"))
  },

  listRequestLogs(req, ok, nok) {
    invokePreFlight("listRequestLogs");
    client
      .post('/api/collection:request-log', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listRequestLogs"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listRequestLogs") })
      .catch((error) => noker(error, nok, "listRequestLogs"))
  },

  listRgps(req, ok, nok) {
    invokePreFlight("listRgps");
    client
      .post('/api/collection:rgp', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listRgps"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listRgps") })
      .catch((error) => noker(error, nok, "listRgps"))
  },

  listTlds(req, ok, nok) {
    invokePreFlight("listTlds");
    client
      .post('/api/collection:tld', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listTlds"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listTlds") })
      .catch((error) => noker(error, nok, "listTlds"))
  },

  listUsers(req, ok, nok) {
    invokePreFlight("listUsers");
    client
      .post('/api/collection:user', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "listUsers"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "listUsers") })
      .catch((error) => noker(error, nok, "listUsers"))
  },

  loginUser(req, ok, nok) {
    invokePreFlight("loginUser");
    client
      .post('/api/user:login', req)
      .then((response) => { oker(response.data, ok, "loginUser"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "loginUser") })
      .catch((error) => noker(error, nok, "loginUser"))
  },

  lookupContact(req, ok, nok) {
    invokePreFlight("lookupContact");
    client
      .post('/api/contact:lookup', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "lookupContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "lookupContact") })
      .catch((error) => noker(error, nok, "lookupContact"))
  },

  lookupRegistrar(req, ok, nok) {
    invokePreFlight("lookupRegistrar");
    client
      .post('/api/registrar:lookup', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "lookupRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "lookupRegistrar") })
      .catch((error) => noker(error, nok, "lookupRegistrar"))
  },

  registrarCommandChecks(req, ok, nok) {
    invokePreFlight("registrarCommandChecks");
    client
      .post('/api/registrar:commandChecks', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "registrarCommandChecks"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "registrarCommandChecks") })
      .catch((error) => noker(error, nok, "registrarCommandChecks"))
  },

  rejectDomainTransfer(req, ok, nok) {
    invokePreFlight("rejectDomainTransfer");
    client
      .post('/api/transfer:reject', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "rejectDomainTransfer"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "rejectDomainTransfer") })
      .catch((error) => noker(error, nok, "rejectDomainTransfer"))
  },

  renewDomain(req, ok, nok) {
    invokePreFlight("renewDomain");
    client
      .post('/api/domain:renew', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "renewDomain"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "renewDomain") })
      .catch((error) => noker(error, nok, "renewDomain"))
  },

  resetUserPasswordAnswer(req, ok, nok) {
    invokePreFlight("resetUserPasswordAnswer");
    client
      .post('/api/user:resetPasswordAnswer', req)
      .then((response) => { oker(response.data, ok, "resetUserPasswordAnswer"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "resetUserPasswordAnswer") })
      .catch((error) => noker(error, nok, "resetUserPasswordAnswer"))
  },

  resetUserPasswordChallenge(req, ok, nok) {
    invokePreFlight("resetUserPasswordChallenge");
    client
      .post('/api/user:resetPasswordChallenge', req)
      .then((response) => { oker(response.data, ok, "resetUserPasswordChallenge"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "resetUserPasswordChallenge") })
      .catch((error) => noker(error, nok, "resetUserPasswordChallenge"))
  },

  setAlphaTldList(req, ok, nok) {
    invokePreFlight("setAlphaTldList");
    client
      .post('/api/settings/domains:setAlphaTldList', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "setAlphaTldList"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "setAlphaTldList") })
      .catch((error) => noker(error, nok, "setAlphaTldList"))
  },

  setDomainBlacklist(req, ok, nok) {
    invokePreFlight("setDomainBlacklist");
    client
      .post('/api/settings/domains:setBlackList', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "setDomainBlacklist"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "setDomainBlacklist") })
      .catch((error) => noker(error, nok, "setDomainBlacklist"))
  },

  setFrontendTranslation(req, ok, nok) {
    invokePreFlight("setFrontendTranslation");
    client
      .post('/api/frontend/translation:set', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "setFrontendTranslation"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "setFrontendTranslation") })
      .catch((error) => noker(error, nok, "setFrontendTranslation"))
  },

  snapshotAggregate(req, ok, nok) {
    invokePreFlight("snapshotAggregate");
    client
      .post('/api/snapshot', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "snapshotAggregate"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "snapshotAggregate") })
      .catch((error) => noker(error, nok, "snapshotAggregate"))
  },

  toggleDomainSUPStatus(req, ok, nok) {
    invokePreFlight("toggleDomainSUPStatus");
    client
      .post('/api/domain:toggleDomainSUPStatus', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "toggleDomainSUPStatus"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "toggleDomainSUPStatus") })
      .catch((error) => noker(error, nok, "toggleDomainSUPStatus"))
  },

  updateContact(req, ok, nok) {
    invokePreFlight("updateContact");
    client
      .post('/api/contact:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateContact") })
      .catch((error) => noker(error, nok, "updateContact"))
  },

  updateDomain(req, ok, nok) {
    invokePreFlight("updateDomain");
    client
      .post('/api/domain:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateDomain"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateDomain") })
      .catch((error) => noker(error, nok, "updateDomain"))
  },

  updateHost(req, ok, nok) {
    invokePreFlight("updateHost");
    client
      .post('/api/host:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateHost"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateHost") })
      .catch((error) => noker(error, nok, "updateHost"))
  },

  updateRegistrar(req, ok, nok) {
    invokePreFlight("updateRegistrar");
    client
      .post('/api/registrar:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateRegistrar") })
      .catch((error) => noker(error, nok, "updateRegistrar"))
  },

  updateTld(req, ok, nok) {
    invokePreFlight("updateTld");
    client
      .post('/api/tld:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateTld"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateTld") })
      .catch((error) => noker(error, nok, "updateTld"))
  },

  updateUser(req, ok, nok) {
    invokePreFlight("updateUser");
    client
      .post('/api/user:update', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "updateUser"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "updateUser") })
      .catch((error) => noker(error, nok, "updateUser"))
  },

  viewContact(req, ok, nok) {
    invokePreFlight("viewContact");
    client
      .post('/api/contact:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewContact"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewContact") })
      .catch((error) => noker(error, nok, "viewContact"))
  },

  viewDomain(req, ok, nok) {
    invokePreFlight("viewDomain");
    client
      .post('/api/domain:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewDomain"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewDomain") })
      .catch((error) => noker(error, nok, "viewDomain"))
  },

  viewDomainRgp(req, ok, nok) {
    invokePreFlight("viewDomainRgp");
    client
      .post('/api/domain:rgp', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewDomainRgp"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewDomainRgp") })
      .catch((error) => noker(error, nok, "viewDomainRgp"))
  },

  viewHost(req, ok, nok) {
    invokePreFlight("viewHost");
    client
      .post('/api/host:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewHost"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewHost") })
      .catch((error) => noker(error, nok, "viewHost"))
  },

  viewRegistrar(req, ok, nok) {
    invokePreFlight("viewRegistrar");
    client
      .post('/api/registrar:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewRegistrar"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewRegistrar") })
      .catch((error) => noker(error, nok, "viewRegistrar"))
  },

  viewTld(req, ok, nok) {
    invokePreFlight("viewTld");
    client
      .post('/api/tld:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewTld"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewTld") })
      .catch((error) => noker(error, nok, "viewTld"))
  },

  viewUser(req, ok, nok) {
    invokePreFlight("viewUser");
    client
      .post('/api/user:view', req, authRequest(sessionToken))
      .then((response) => { oker(response.data, ok, "viewUser"); tokenH(response.headers, tokenHandler); }, (error) => { noker(error, nok, "viewUser") })
      .catch((error) => noker(error, nok, "viewUser"))
  },

}



// WEBPACK FOOTER //
// ./src/api/index.js